import React from 'react';
import { motion } from 'framer-motion';
export function RevelationSection() {
  return <section className="bg-cream py-10 px-6 md:py-16" data-id="element-222">
      <div className="max-w-3xl mx-auto" data-id="element-223">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="border-l-4 border-[#C07050] pl-6 md:pl-8 space-y-5 text-lg leading-relaxed" data-id="element-224">
          <p data-id="element-225">Les gens t'ont dit deux choses :</p>

          <div className="space-y-3" data-id="element-226">
            <p data-id="element-227">
              <span className="mr-2" data-id="element-228">❌</span>
              <span className="line-through text-gray-500" data-id="element-229">
                "Tourne la page."
              </span>
            </p>
            <p data-id="element-230">
              <span className="mr-2" data-id="element-231">❌</span>
              <span className="line-through text-gray-500" data-id="element-232">
                "Trouve quelqu'un d'autre."
              </span>
            </p>
          </div>

          <p className="text-xl font-semibold text-charcoal" data-id="element-233">
            Ils ont tous tort.
          </p>

          <p data-id="element-234">
            Ta reconstruction n'a besoin ni d'un avocat, ni d'un thérapeute, ni
            d'une app de rencontres.
          </p>

          <p className="text-xl" data-id="element-235">Elle a besoin d'une seule chose.</p>

          <p data-id="element-236">Redevenir, enfin...</p>

          <p className="text-3xl font-playfair font-bold text-burgundy" data-id="element-237">TOI.</p>
        </motion.div>
      </div>
    </section>;
}